import fetch from 'isomorphic-unfetch';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';
import LegalText from '../components/LegalText.js';
import Head from 'next/head';

export default class Legal extends React.Component {
  static async getInitialProps({ query }) {
    const res = await fetch(`${CONSTANTS.API_URL}?legal=${query.type}`);
    const data = await res.json();

    const type = query.type === 'terms' ? 'Terms of Use' : 'Privacy policy';

    const description = query.type === 'terms'
      ? 'Your access to and use of SiteSee is conditioned upon your acceptance of and compliance with these terms.'
        : 'This page informs you of our policies regarding the collection, use and disclosure of Personal Information when you use our Service.';

    return {
      data: data,
      type,
      description,
    }
  }

  render () {
    return (
      <React.Fragment>
        <Head>
          <title>SiteSee - {this.props.type}</title>
          <meta name="description" content={this.props.description}></meta>
          <meta property="og:locale" content="en_US"></meta>
          <meta property="og:type" content="website"></meta>
          <meta property="og:site_name" content="SiteSee"></meta>
          <meta property="og:title" content="SiteSee"></meta>
          <meta property="og:url" content="https://sitesee.co"></meta>
          <meta property="og:image" content="https://d3alngem7je9z2.cloudfront.net/sitesee_banner.png"></meta>
          <meta property="og:description" content="A curated gallery of beautiful, modern websites meant to inspire web developers and designers."></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@siteseegallery"></meta>
          <meta name="twitter:title" content="SiteSee"></meta>
          <meta name="twitter:description" content="A curated gallery of beautiful, modern websites."></meta>
          <meta name="twitter:image" content="https://d3alngem7je9z2.cloudfront.net/sitesee_banner.png"></meta>
        </Head>
        <LegalText content={this.props.data.html} />
      </React.Fragment>
    );
  }
};

Legal.contextType = ModalContext;
